<template>
    <phone-wrap></phone-wrap>
</template>

<script>
    import PhoneWrap from '@/components/phone/phone-wrap.vue'
    export default {
        name: "mobileClient",
        components:{
            PhoneWrap
        }
    }
</script>

<style scoped>

</style>
